
















































import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { toDemotion } from '@core/utils/helper'
import dayjs from 'dayjs'
import { productLinkUrl } from '@/app/core/utils'
import { toNumber } from 'lodash'

const TicketType = new Map([
  [0, ''],
  [1, '儿童'],
  [2, '老人'],
  [3, '男人'],
  [4, '女人'],
  [5, '其他'],
  [6, '学生'],
  [7, '成人'],
  [8, '优待'],
  [9, '亲子家庭']
])

@Component({})
export default class BusinessItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200031')
  clickid_200031!: string
  get ticketType() {
    const type = TicketType.get(this.value.peopleGroup)
    return type ? `${type}票` : ''
  }

  get goDetail() {
    return productLinkUrl(this.value.linkUrl, 3)
  }

  goDetailClick = () => {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200031, positionParam: { name: this.value.spuName } })
  }

  get tags() {
    const tag: string[] = []
    if (this.value.isSpotDiscount === 1) {
      tag.push('超级补贴')
    }
    if (this.value.firstBookingDate) {
      const day = dayjs(this.value.firstBookingDate)
      const tomorrow = dayjs().add(1, 'd')
      if (day.isSame(new Date(), 'day')) {
        tag.push('可订今日')
      } else if (day.isSame(tomorrow, 'day')) {
        tag.push('可订明日')
      } else if (day.isAfter(new Date())) {
        tag.push(`可订${day.format('M月D日')}`)
      }
    }
    if (this.value.isScheduler === 0) {
      tag.push('随买随用')
    } else {
      tag.push('需预约')
    }
    if (this.value.quickEnter) {
      tag.push('无需取票')
    } else {
      tag.push('需取票')
    }
    if (this.value.isAnyTimeRefund === 1) {
      tag.push('随时退')
    } else if (this.value.isAnyTimeRefund === 2) {
      tag.push('条件退')
    }
    return tag
  }

  get distance() {
    return this.value.distance
  }
  get spotScore() {
    return parseInt(this.value.spotScore)
  }

  get minOrginPrice() {
    return toDemotion(this.value.minOrginPrice)
  }

  get minPrice() {
    return toDemotion(this.value.minPrice)
  }

  get promotion() {
    return toDemotion(this.value.minOrginPrice - this.value.minPrice)
  }
}
